
import { Button } from 'primereact/button';
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';


const ThankYouCollectPayment = () => {
     const navigate = useNavigate();
     
     const location = useLocation();
     const {  bookingOrderId ,storeCustomerId} = location.state || {}; // Fallback to prevent undefined errors
   
     const handleBackButton = () => {
        navigate('/OrdersGarmentInfo', {state:{
          storeCustomerId: storeCustomerId,
          bookingOrderId: bookingOrderId,
        }});
     }
  return (
    <div className='flex flex-1 justify-content-center '>
      <div className='flex flex-column justify-content-center align-items-center'>
        <img
          src={'VectorsLaundryApp/DhobiCart.png'}
          style={{
            width:   400,
            
          }}
        />
        <p className='text-3xl font-medium'>Thanks To Choose Online Payment Mode</p>
        <p className='text-3xl font-medium'>Please Go Back</p>
        <Button
                  className="mt-3 mb-3 mx-4 border-round-xl flex-1 "
                  onClick={handleBackButton}
                >
                  <p className=" w-full text-2xl font-semibold flex justify-content-center">
                    Back To Dhobi cart
                  </p>
                </Button>
      </div>
    </div>
  );
}


export default ThankYouCollectPayment


 
